<div class="page-heading">
  <div class="heading-left">
    <h1 class="title">{{ 'dashboard.welcomeHeading' | translate }}</h1>
    <p class="subtitle">{{ 'dashboard.subtitle' | translate }}</p>
  </div>
</div>

<div class="report-cards">
  <div class="card" aria-label="Inbox">
    <div class="card-row">
      <div class="card-icon" aria-hidden="true">
        <img src="/assets/icons/dashboard/inbox.svg" alt="Inbox">
      </div>
      <div class="card-text">
        <div class="card-title">{{ 'dashboard.card.inbox' | translate }}</div>
        <div class="card-value" [class.count-done]="inboxDone">
          <span class="counter-skeleton" *ngIf="isLoadingCounters"></span>
          <span *ngIf="!isLoadingCounters">{{ inboxCount }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-row">
      <div class="card-icon" aria-hidden="true">
        <img src="/assets/icons/dashboard/request-issued.svg" alt="Request Issued">
      </div>
      <div class="card-text">
        <div class="card-title">{{ 'dashboard.card.requestsIssued' | translate }}</div>
        <div class="card-value" [class.count-done]="requestsIssuedDone">
          <span class="counter-skeleton" *ngIf="isLoadingCounters"></span>
          <span *ngIf="!isLoadingCounters">{{ requestsIssued }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-row">
      <div class="card-icon" aria-hidden="true">
        <img src="/assets/icons/dashboard/sent-request.svg" alt="Sent Requests">
      </div>
      <div class="card-text">
        <div class="card-title">{{ 'dashboard.card.sentRequests' | translate }}</div>
        <div class="card-value" [class.count-done]="sentRequestsDone">
          <span class="counter-skeleton" *ngIf="isLoadingCounters"></span>
          <span *ngIf="!isLoadingCounters">{{ sentRequests }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-row">
      <div class="card-icon" aria-hidden="true">
        <img src="/assets/icons/dashboard/closed-request.svg" alt="Closed Requests">
      </div>
      <div class="card-text">
        <div class="card-title">{{ 'dashboard.card.closedRequests' | translate }}</div>
        <div class="card-value" [class.count-done]="closedRequestsDone">
          <span class="counter-skeleton" *ngIf="isLoadingCounters"></span>
          <span *ngIf="!isLoadingCounters">{{ closedRequests }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
